import * as React from "react";
import { LazyRender } from "sb-resp-ui";
import { EventsFromTopLeaguesBySportIdRequest } from "sb-bff-integration";
import { EventListView } from "../EventListView";
export class EventList extends React.PureComponent {
    render() {
        const view = [];
        const eventsLength = this.props.events.length;
        const eventToShow = Math.min(eventsLength, this.props.cms.ExpandedEvents);
        let currChunk = 0;
        for (let current = 0; current < eventToShow;) {
            const baseMinHeight = this.props.eventChunkHeights[currChunk++];
            const start = current;
            const max = current + this.props.state.EVENTS_CHUNK_SIZE;
            current = Math.min(max, eventToShow);
            view.push(React.createElement(LazyRender, { baseMinHeight: baseMinHeight, key: `k-lazy-${current}`, observerOptions: {
                    threshold: 0,
                    rootMargin: "100px 0px"
                } },
                React.createElement(EventListView, { state: this.props.state, endIndex: current, startIndex: start, events: this.props.events, cms: this.props.cms, dict: this.props.dict })));
        }
        const filteredEvents = this.props.events.filter(x => x.type === EventsFromTopLeaguesBySportIdRequest.EventTypesEnum.Outright.toString());
        eventToShow < eventsLength
            && !this.props.cms.ShowViewAllLive
            && !filteredEvents.length
            && view.push(this.props.children);
        return view;
    }
}
//# sourceMappingURL=EventList.js.map